// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"45bd96d2","453":"af37b82c","699":"80592efe"}[chunkId] + ".chunk.js";
};